import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LineChart, Line, ComposedChart, CartesianGrid } from "recharts";
import { CustomTooltipPowerSteering } from "../ChartUtils";
// const data = [
//     { name: "Jan 24", series1: 4000, series2: 2400, series3: 3500 },
//     { name: "Feb 24", series1: 3000, series2: 1398, series3: 3200 },
//     { name: "Mar 24", series1: 2000, series2: 9800, series3: 5000 },
//     { name: "Apr 24", series1: 2780, series2: 3908, series3: 4500 },
//     { name: "May 24", series1: 1890, series2: 4800, series3: 4100 },
//     { name: "Jun 24", series1: 2390, series2: 3800, series3: 4700 },
//     { name: "Jul 24", series1: 3490, series2: 4300, series3: 4900 },
//     { name: "Aug 24", series1: 4200, series2: 2100, series3: 3800 },
//     { name: "Sep 24", series1: 3100, series2: 5000, series3: 4500 },
//     { name: "Oct 24", series1: 2700, series2: 3700, series3: 4300 },
//     { name: "Nov 24", series1: 2900, series2: 4200, series3: 4700 },
//     { name: "Dec 24", series1: 3300, series2: 4600, series3: 5200 },
// ];

const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={5} // Adjust vertical alignment
                textAnchor="end" // Align the text properly
                transform="rotate(270)" // Rotate the text by 90 degrees
                fill="#616161"
                style={{ fontSize: "14px" }}
            >
                {payload.value}
            </text>
        </g>
    );
};

const CustomizedYTick = ({ x, y, payload }) => {
    const value = parseFloat(payload.value);
    const roundedValue = Number.isInteger(value) ? value : value.toFixed(2);

    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={-5}             
                y={0}
                dy={4}
                textAnchor="end"
                fill="#616161"
                style={{ fontSize: "14px" }}
            >
                {roundedValue}
            </text>
        </g>
    );
};
function findMinMax(data) {
    let values = [];
    
    data.forEach(item => {
        Object.keys(item).forEach(key => {
            if (key !== "monthName" && item[key] !== null) {
                const num = parseFloat(item[key]);
                if (!isNaN(num)) {
                    values.push(num);
                }
            }
        });
    });
    return {
        min: Math.min(...values),
        max: Math.max(...values)
    };
}
// const generateTicks = (minValue, maxValue) => {
//   console.log(minValue, maxValue)
//   const maxAbs = Math.max(Math.abs(minValue), Math.abs(maxValue));
//   const step = maxAbs / 5; // Ensure equal spacing
  
//   return [...Array(11)].map((_, i) => (i - 5) * step);
// };

const generateTicks = (minValue, maxValue) => {
    let start = Math.ceil(minValue / 10) * 10;
    let end = Math.floor(maxValue / 10) * 10;
    let ticks = [];
    if(start==0 && end==0) {
        const min = Math.min(minValue, 0);
        // const max = Math.max(maxValue, 0);
        // const range = max - min;
        // const step = range / 10 || 0.2;
        const maxAbs = Math.max(Math.abs(minValue), Math.abs(maxValue));
        const step = (2 * maxAbs) / 10 || 0.2; // 10 steps from -max to +max
        //console.log(min,max)
        // Calculate 5 ticks below and 5 above 0 using step)
        if (min < 0) {
            for (let i = -5; i <= 5; i++) {
                ticks.push(parseFloat((i * step).toFixed(3)));
            }
        } else {
            for (let i = 0; i <= 5; i++) {
                    ticks.push(parseFloat((i * step).toFixed(3)));
                }
        }
    } else {
        if(Math.abs(start)==0 && minValue<0){
            start = -10;
        }
        const diff = end - start;
        const tickstep = diff>200 ? 20 : 10;
        for (let i = start; i <= 0; i += tickstep) {
            ticks.push(i);
        }
        if (!ticks.includes(0)) {
            ticks.push(0);
        }
        for (let i = tickstep; i <= end; i += tickstep) {
            ticks.push(i);
        }
    }
    
    return ticks;
};

const CustomTooltip = ({ active, payload, label }) => {
    
    return CustomTooltipPowerSteering(active, payload, label,'monthName','actual','planned','forecast');

};
const MOMProductivityChart = ({ data }) => {
    const result = findMinMax(data);
    const roundUpToNearest5 = (value) => Math.floor(value / 5) * 5;
    const roundUpToNearest5Positive = (value) => Math.ceil(value / 5) * 5;
    //let minValue = result?.min>0?0:result?.min>-5?result?.min*1.2:roundUpToNearest5(result?.min)
    //let maxValue = result?.max<0?0:result?.max<5?result?.max*1.2:roundUpToNearest5Positive(result?.max)
    let minValue = result?.min>0?0:result?.min>-5?result?.min:roundUpToNearest5(result?.min)
    let maxValue = result?.max<0?0:result?.max<5?result?.max:roundUpToNearest5Positive(result?.max)
    // console.log(data)
    // console.log(result)
    // console.log(minValue,maxValue)
    // console.log(generateTicks(minValue, maxValue))
    
    const start = Math.ceil(minValue / 10) * 10;
    const end = Math.floor(maxValue / 10) * 10;
    minValue = Math.min(minValue, 0)*1.2;
    maxValue = Math.max(maxValue, 0)*1.2;
    
    // console.log(minValue,maxValue)
    const allTicks = generateTicks(minValue, maxValue)
    const minRange = allTicks[0]
    const maxRange = allTicks[allTicks.length-1]
    return (
        // <div style={{ width: "100%", maxHeight: "400px", overflowY: "auto" }}>
        //     <div style={{ width: '100%', heigh:"100%" }}>
                <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 50 }}>
                        <CartesianGrid horizontal={true} vertical={false} stroke='#DFDFDF' />
                        <XAxis dataKey="monthName" tick={<CustomizedTick />} interval={0} axisLine={false} tickLine={false} />
                        <YAxis axisLine={false} tick={<CustomizedYTick />}
                         tickLine={false} 
                        //  domain={[minValue,maxValue]} 
                        domain={[minRange,maxRange]} 
                         interval={0} ticks={generateTicks(minValue, maxValue)} />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="actual" fill="#0078A7" barSize={11} radius={[10, 10, 0, 0]} />
                        <Bar dataKey="planned" fill="#B05788" barSize={11} radius={[10, 10, 0, 0]} />
                        <Line type="linear" dataKey="forecast" stroke="#ff7300" strokeWidth={3} activeDot={false}
                             dot={{ fill: "#ff7300", stroke: "#ff7300", strokeWidth: 2 }} />
                    </ComposedChart>
                </ResponsiveContainer>
        //     </div>
        // </div>
    );
};


export default MOMProductivityChart;
